import { render } from "./EmployeeApprovalsNewVerification.vue?vue&type=template&id=2f2358ae"
import script from "./EmployeeApprovalsNewVerification.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsNewVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__